module.exports = __webpack_public_path__ + "img/nogroupimg.e51da43c.svg";